<template>
  <div class="comments pt-0">
    <div class="" v-if="!loader">
      <div class="my-3" v-if="!$store.getters.GET_PREVIEW_COMMENT.length">
        <h3>No comments on this file</h3>
      </div>
      <div
        class="comment-section"
        v-if="$store.getters.GET_PREVIEW_COMMENT.length"
      >
        <h3>
          <span>Comments ({{ $store.getters.GET_TOTAL_COMMENT }})</span>
          <span class="view_all" @click="view_comment">View all</span>
        </h3>
        <div
          v-for="(comment, index) in $store.getters.GET_PREVIEW_COMMENT"
          :key="index"
          class="comment"
        >
          <div class="user">
            <img
              src="@/assets/icons8-male-user-48.png"
              v-if="comment.img == ''"
            />
            <img :src="comment.img" v-if="comment.img != ''" />
          </div>
          <div class="comment-text">
            <div class="name">
              <span class="text-truncate">
                <strong>{{ comment.name }}</strong>
              </span>
              <span class="date">{{ format_date(comment.createdAt) }}</span>
              <span
                class="edit"
                v-if="$store.getters.GET_COMMENTER_ID == comment.user_id"
                @click="editcomment(comment)"
                >Edit</span
              >
            </div>
            <div class="comment">
              {{ comment.comment }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loader">
      <span class="loader" v-if="loader">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid"
          viewBox="0 0 100 100"
          width="40px"
          height="40px"
          class="lds-dual-ring"
          style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke-linecap="round"
            stroke="#039aed"
            r="30"
            stroke-dasharray="41.41592653589793 41.41592653589793"
            stroke-width="8"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            ></animateTransform>
          </circle>
        </svg>
        Loading file comments
      </span>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";

export default {
  data() {
    return {
      comments: [],
      loader: false,
      file_id: "",
      name: "",
    };
  },
  methods: {
    reply(comment) {
      this.$parent.reply(comment);
    },
    editcomment(data) {
      this.$parent.editcomment(this.name, data);
    },
    ...mapMutations([
      "UPDATE_PREVIEW_COMMENT",
      "UPDATE_TOTAL_COMMENT",
      "HIDE_FILE_INFO",
      "UPDATE_COMMENTER_ID",
    ]),
    logincall() {
      this.$parent.logincall();
    },

    format_date(date) {
      //  return moment(date).format('YYYY-MM-DD HH:MM:SS A')
      return moment(date).fromNow(); // 8 years ago
    },
    view_comment() {
      this.$parent.comments(this.file_id);
    },
    load(id) {
      this.loader = true;
      this.file_id = id;

      let data = {
        token: cookies.getCookie("token"),
        id: id,
        limit: true,
      };

      let that = this;

      this.$socket.emit("get-comments", data, function (data) {
        if (data.message === "completed") {
          that.loader = false;
          that.name = data.name;
          that.UPDATE_PREVIEW_COMMENT(data.comments);
          that.UPDATE_TOTAL_COMMENT(data.total_comments);
          that.UPDATE_COMMENTER_ID(data.commenter_id);
        }

        if (data.data === false) {
          that.HIDE_FILE_INFO();
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
  },
};
</script>
